import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const C = {
  h1: (p) => <h3 className="mb-2 mt-4 font-display text-xl font-extrabold uppercase text-white first:mt-0" {...p} />,
  h2: (p) => <h4 className="mb-2 mt-4 font-display text-lg font-bold uppercase text-white first:mt-0" {...p} />,
  h3: (p) => <h5 className="mb-1 mt-3 font-semibold text-white first:mt-0" {...p} />,
  h4: (p) => <h6 className="mb-1 mt-3 text-sm font-semibold text-white" {...p} />,
  p: (p) => <p className="mb-2 leading-relaxed" {...p} />,
  strong: (p) => <strong className="font-semibold text-white" {...p} />,
  ul: (p) => <ul className="mb-2 list-disc space-y-1 pl-5" {...p} />,
  ol: (p) => <ol className="mb-2 list-decimal space-y-1 pl-5" {...p} />,
  table: (p) => <div className="mb-3 overflow-x-auto"><table className="w-full text-xs" {...p} /></div>,
  th: (p) => <th className="border-b border-slate-700 px-2 py-1.5 text-left font-data text-[10px] uppercase tracking-wider text-slate-400" {...p} />,
  td: (p) => <td className="border-b border-slate-800 px-2 py-1.5" {...p} />,
  a: (p) => <a className="text-[#FF2D78] underline" target="_blank" rel="noreferrer" {...p} />,
  code: (p) => <code className="rounded bg-[#0B0F19] px-1 font-data text-xs" {...p} />,
};

export const Markdown = ({ children, testId }) => (
  <div data-testid={testId} className="text-sm text-slate-300">
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={C}>{children || ""}</ReactMarkdown>
  </div>
);
